import React, {useState} from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Container from '@mui/material/Container';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './Header';
import Footer from './Footer';
import Home from './Home';
import InventoryPage from './InventoryPage';
import DataETL from './DataETL';

function App() {
  const [pinGood, setPinGood] = useState(false);

  return (
    <Router>
      <CssBaseline />
      <Header />
      <Container component="main" sx={{ mt: 8, mb: 8 }}>
        <Routes>
          <Route path="/" element={<Home pinGood={pinGood} setPinGood={setPinGood}/>} />
          <Route path="/inventory" element={<InventoryPage pinGood={pinGood} setPinGood={setPinGood}/>} />
          <Route path="/dataetl" element={<DataETL pinGood={pinGood} setPinGood={setPinGood}/>} />
        </Routes>
      </Container>
      <Footer />
    </Router>
  );
}

export default App;
